<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar rounded dense elevation="1" color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="breadcrumbsItems" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar color="secondary" flat> 
                        <v-toolbar-title>
                            Add Item Account
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-undo" tooltip="Cancel" @click="handleCancel"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                        <v-col cols="12" md="12">
                            <ItemAccountForm 
                                ref="form" 
                                v-model="form" 
                                v-if="!itemLoading"
                            />
                        </v-col>
                        <div v-if="itemLoading">
                           <v-col >
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                        </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PAlert from './../../components/common/PAlert.vue'
import PIconBtn from "./../../components/common/PIconBtn.vue"
import ItemAccountForm from "./../../components/warehouse/ItemAccountForm.vue";
import { v4 as uuid } from 'uuid';

export default {
    name: "ItemAccountCreate",
    components: {
        PIconBtn,
        ItemAccountForm,
        PAlert
    },
    data() {
        return {
            breadcrumbsItems: [
                { text: 'Warehouse & Inventory'},
                { text: 'Account' },
                { text: 'Add Account' }
            ],
            form: null,
            itemLoading: false,
            loading: false,
            itemId: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            idempotentKey: null
        }
    },
    methods: {
        ...mapActions({
            findByID: "stock/item/findByID",
            pushItem: "stock/item/search/push",
            snackbar: "ui/snackbar/show",
            create: "stock/itemAccount/create"

        }),
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to Save", callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.form, idempotentKey: this.idempotentKey}).then(() => {
                this.snackbar({ text: "Item Account Create", color: "success"})
                this.$router.push({ name: "ItemDisplay", params: { id : this.itemId }, query: { tab: 'accounts' }})
            }).catch(error => {
                let message = error.response? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            })
        },
        fetchItem() {   
            this.itemLoading = true;
            this.findByID(this.itemId).then(response => {
                this.pushItem(response.data);
                this.form = {};
                this.form.item_id = response.data.id;
            }).finally(() => {
                this.itemLoading = false;   
            })
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Cancel?", callback: this.cancel};
        },
        cancel() {
            this.$router.push({ name: "ItemDisplay", params: { id : this.itemId }, query: { tab: "accounts" } })
        }
    },
    mounted() {
        if(this.$route.params.id) {
            this.itemId = this.$route.params.id;
            this.fetchItem();
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>
</style>